<template>
  <div class="paymentInfo">
    <Loading v-if="loading" />
    <div class="paymentInfo__title">
      <p class="paymentInfo">
        {{ $t('paymentDetails') }}
      </p>
    </div>
    <div class="paymentInfo__info">
      <div class="info">
        <p>{{ $t('issuePayment') }}</p>
        <span class="valueInfo">
          {{ getIssuePayment(paymentInfo?.issuedAt) }}
        </span>
        <span v-if="paymentInfo?.issuedAt" class="timeInfo">
          ({{ getTime(paymentInfo?.issuedAt) }} )</span
        >
      </div>
      <div v-if="paymentInfo?.reference" class="info">
        <p>{{ $t('reference') }}</p>
        <span class="valueInfo">
          {{ paymentInfo?.reference }}
        </span>
      </div>
      <div v-if="paymentInfo?.totalSum" class="info">
        <p>{{ $t('totalSum') }}</p>
        <span class="valueInfo">
          {{ paymentInfo?.totalSum }}
        </span>
      </div>
      <div v-if="paymentInfo?.comment" class="info">
        <p>{{ $t('customerReceiptMessage') }}</p>
        <span class="valueInfo">
          {{ paymentInfo?.comment }}
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import moment from 'moment';
import { Options, Vue } from 'vue-class-component';

import Loading from '@/views/Loading.vue';

@Options({
  name: 'PaymentInfo',
  props: ['paymentInfo'],
  components: {
    Loading
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    getIssuePayment(value: boolean) {
      if (value) {
        return `${this.$t('yes')}`;
      } else {
        return `${this.$t('no')}`;
      }
    },
    getTime(time: number) {
      if (time) {
        return moment(time).format('DD.MM.YYYY HH:mm');
      }
    }
  }
})
export default class PaymentInfo extends Vue {}
</script>

<style lang="scss">
.paymentInfo {
  .paymentInfo__title {
    position: relative;
    width: 100%;
    margin-top: 31px;
    .paymentInfo {
      font-family: 'Ubuntu-Medium';
      font-size: $sixteenSize;
      color: $main-text;
    }
    &::after {
      content: '';
      position: absolute;
      top: 9px;
      left: 150px;
      width: 100%;
      height: 1px;
      background: $ligher-grey;
    }
    &::before {
      content: '';
      position: absolute;
      top: 7px;
      left: 145px;
      width: 5px;
      height: 5px;
      border-radius: 8px;
      background: $ligher-grey;
    }
  }
  .paymentInfo__info {
    .info {
      margin-top: 32px;
      p {
        color: $label;
        font-size: $twelveSize;
        line-height: $fourteenSize;
        padding-bottom: 7px;
      }
      .valueInfo {
        color: $mid-grey;
        font-size: $fourteenSize;
      }
      .timeInfo {
        font-size: $fourteenSize;
        color: $servicesTitle;
        margin-left: 5px;
      }
    }
  }
}
</style>
